import React from 'react'
import { UserIcon } from '../../svg'
import styles from "../header/header.module.css";

const Home = () => {
  return (
    <div className={styles.iconStyle}><UserIcon/></div>
  )
}

export default Home